import * as Sentry from '@sentry/browser'

Sentry.init({ dsn: "https://865d57064c9e49508f631881d477520f@sentry.asbjornenge.com/28" })
